import React, { PureComponent } from "react";
import Navbar from "../NavBar/NavBar";
import "../../StylesPages/profile.css";
import ShowProfile from "../ShowProfile";
import { Box, Text } from "@chakra-ui/react";

export class Profil extends PureComponent {
  render() {
    return (
      <>
        <div className="profile-container">
          <Navbar />

          <div className="profile-content ">
            <Box p={4}>
              <Text
                fontFamily={"Sofia pro"}
                fontSize={"5xl"}
                fontWeight={"bolder"}
                marginBottom={["20px", "20px", "40px", "40px"]}
                marginStart={["10px", "10px", "80px", "80px"]}
              >
                Votre profil
              </Text>
              <div className="">
                <ShowProfile></ShowProfile>
              </div>
            </Box>
          </div>
        </div>
      </>
    );
  }
}

export default Profil;
